import Header from '../../components/Header.tsx';
import Footer from '../../components/Footer.tsx';
import { useNavigate, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';

const Verification = () => {

  const navigate = useNavigate();
  const { email } = useParams(); // pega o token codificado da URL
  const baseUrl = process.env.REACT_APP_BASE_API_URL;

  const [decodedEmail, setDecodedEmail] = useState('');
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (email) {
      try {
        setDecodedEmail(atob(email)); // decode direto
      } catch {
        console.error("Erro ao decodificar email");
      }
    }
  }, [email]);

  const resendToken = async () => {
    if (!decodedEmail) {
      alert("Email inválido. Faça o cadastro novamente.");
      return;
    }

    setSending(true);
    try {
      const response = await fetch(`${baseUrl}/api/auth/send/token`, {
        method: 'POST',
        body: JSON.stringify({ email: decodedEmail }),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        alert("Verification email resent successfully!");
      } else {
        alert("Failed to resend email.");
      }
    } catch (error) {
      console.error(error);
      alert("Erro ao reenviar email.");
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <Header />

      <section className="account padding-top padding-bottom sec-bg-color2">
        <div className="container">
          <div className="account__wrapper">
            <div className="row g-4">
              <div className="col-12">
                <div className="account__content account__content--style1">
                  <div className="account__header">
                    <h2>Account Verification</h2>

                    <p>
                      A message was sent to <b>{decodedEmail || "your email"}</b> for your account verification.
                      Please check your inbox or spam folder.
                    </p>

                    <p>
                      If you didn't receive the email, click the button below to resend it.
                    </p>
                  </div>

                  <div className="account__divider account__divider--style1">
                    <span></span>
                  </div>

                  <button
                    type="button"
                    className="trk-btn trk-btn--border trk-btn--primary d-block mt-4"
                    onClick={resendToken}
                  >
                    {sending ? "Sending..." : "Resend Verification Email"}
                  </button>

                  {/* <button
                    type="button"
                    className="trk-btn trk-btn--secondary d-block mt-3"
                    onClick={() => navigate('/login')}
                  >
                    Go to Login
                  </button> */}

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Verification;
